import { Http } from "@angular/http";
import { VehicleAttributeModel } from "./../../vehicle-attribute/models/vehicleattribute.model";
import { VehicleAttributeService } from "./../../vehicle-attribute/models/vehicleattribute.service";
import { TranslateService } from "./../../shared/translate/translate.service";
import { AuthService } from "./../../shared/models/auth.service";
import { Component, OnInit, OnDestroy, ViewChild, Input } from "@angular/core";
import { NgForm } from "@angular/forms";
import { VehicleModel } from "../models/vehicle.model";
import { VehicleService } from "../models/vehicle.service";
import { Router, ActivatedRoute } from "@angular/router";
import {
  WeGoConfig,
  IAPIResponse,
  ApplicationRouteURL,
  DataListModel,
  WeGoAuthorizedLink,
  Permission,
  PermissionType,
  RoleLevel
} from "../../shared/config";
import { Location } from "@angular/common";
import { GeoLocationService } from "../../shared/models/geolocation.service";
import { DecimalFormatterService } from "../../shared/models/decimal-formatter.service";
import { ModalDirective } from 'ng2-bootstrap/components/modal';

@Component({
  selector: "wego-vehicle-information",
  template: require('../views/vehicle-information.component.html'),
  styles: [
    `       .clear-div {
              clear: both;
            }
            span.label.label-default{
              font-size: 13px;
              line-height: 35px;
              background-color: #eeeeee;
              color: #2BA2AA;
              margin-right: 5px;
            }
            .modal.and.carousel {
              position: fixed;
            }
  `
  ],
  providers: [
    VehicleService,
    VehicleAttributeService,
    GeoLocationService,
    DecimalFormatterService
  ]
})
export class VehicleInformationComponent implements OnInit, OnDestroy {
  vehicleListLink: WeGoAuthorizedLink;
  viewVehicleLink: WeGoAuthorizedLink;
  updateVehicleLink: WeGoAuthorizedLink;
  vtsTroubleShootLink: WeGoAuthorizedLink;
  updateCompanyLink: WeGoAuthorizedLink;

  private vehicleMasterHashId: string;
  private sub: any;
  private popupMsg: string;
  private module: string;
  private breadCrumbTitle: string;
  private breadCrumbList: string;
  public headers: any = this.authService.GetHeaderForFile();

  DataListModel: DataListModel;
  model: VehicleModel;
  apiResponse: IAPIResponse;
  vehicleList: VehicleModel[];
  vehicleAttributeList: VehicleAttributeModel[] = [];
  errorMessage: string;
  message: string;
  isEditMode: boolean;
  urlDefaultPage: string;
  urlVehicleList: string;
  isLoading = true;
  urlVehicleInfo: string;
  popupTitle: string;
  apiErrorMsg: string;
  locationDataExchangeHashId: string;
  damageReportList: any[];
  urlUpdateDamageStatus: string;
  reportDamageHashId: string;
  confirmMsg: string;
  isMobileRequest: boolean = false;
  urlVtsTroubleShoot: string;
  vtsLocationAddress: string;
  urlVehicleUpdate: string;
  urlCompanyUpdate: string;
  urlBookingInformation: string;
  roleLevel = RoleLevel;

  public fileListQuer: string[] = [];

  @ViewChild("confirmModal") public confirmModal: any;
  @ViewChild("googleMapComp") public googleMapComp: any;
  @ViewChild("successPopup") public successPopup: any;
  @ViewChild("successPopupReport") public successPopupReport: any;
  @ViewChild("reportDamageModal") public reportDamageModal: any;
  @ViewChild("damageImageSliderModel") public damageImagesModal: ModalDirective;

  constructor(
    private vehicleService: VehicleService,
    private vehicleAttributeSerive: VehicleAttributeService,
    private activeRoute: ActivatedRoute,
    private authService: AuthService,
    private translate: TranslateService,
    private router: Router,
    private http: Http,
    private locationService: Location,
    private geoLocationService: GeoLocationService,
    private decimalFormatter: DecimalFormatterService
  ) { }

  ngOnInit() {
    this.module = this.translate.instant("LblVehicle");
    this.DataListModel = new DataListModel();
    this.DataListModel.itemsPerPage = 4;
    this.urlDefaultPage = this.authService.GetURL(
      ApplicationRouteURL.URL_DEFAULT_PAGE
    );
    this.urlVehicleList = this.authService.GetURL(
      ApplicationRouteURL.URL_VEHICLE_LIST
    );
    this.urlUpdateDamageStatus = this.authService.GetURL(
      ApplicationRouteURL.URL_REPORT_DAMGE_UPDATE
    );
    this.urlVtsTroubleShoot = this.authService.GetURL(
      ApplicationRouteURL.URL_VTS_TROUBLESHOOT
    );
    this.urlVehicleUpdate = this.authService.GetURL(
      ApplicationRouteURL.URL_VEHICLE_UPDATE
    );
    this.urlCompanyUpdate = this.authService.GetURL(
      ApplicationRouteURL.URL_COMPANY_UPDATE
    );
    this.urlBookingInformation = this.authService.GetURL(
      ApplicationRouteURL.URL_BOOKING_INFORMATION
    );
    this.model = new VehicleModel();
    this.GetVehicleAttributeList();
  }

  public OnBackClick() {
    this.locationService.back();
  }

  public UpdateDamageReportStatus() {
    this.isLoading = true;
    this.vehicleService
      .UpdateReportDamageStatus(this.reportDamageHashId)
      .subscribe(
        (res: any) => {
          this.apiResponse = res;
          this.popupMsg = this.translate.instant(
            "LblVehicleDamgeResolveSuccess"
          );
          this.ShowReportSuccessPopup();
          this.isLoading = false;
        },
        (error: any) => {
          this.errorMessage = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        }
        // () => {
        //   this.GetVehicleDamageReport();
        // }
      );
  }

  public UpdateVehicleDetails() {
    this.isLoading = true;
    this.vehicleService
      .UpdateVehicleForCleaningAndFuel(
        this.model.vehicleMasterHashId,
        this.model.isCleaningRequire,
        this.model.isFuelRequire
      )
      .subscribe(
        (res: any) => {
          this.apiResponse = res;
          this.popupMsg = this.translate.instant("LblVehicleInfoSuccess");
          this.ShowSuccessPopup();
          this.isLoading = false;
        },
        (error: any) => {
          this.errorMessage = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        },
        () => this.UpdateVehicleForInvalidTag()
      );
  }

  public UpdateVehicleForInvalidTag() {
    this.vehicleService
    .UpdateVehicleForInvalidTag(
      this.model.vehicleMasterHashId,
      this.model.invalidTagUsed
    )
    .subscribe(
      (res: any) => {
        this.apiResponse = res;
      },
      (error: any) => {
        this.errorMessage = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      },
      () => this.GetVehicleDetails()
    );
  }

  public GetVehicleAttributeList() {
    this.vehicleAttributeSerive.GetVehicleAttributeList().subscribe(
      (res: any) => {
        this.apiResponse = res;
        this.vehicleAttributeList = res.data;
      },
      (error: any) => {
        this.errorMessage = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      },
      () => this.GetVehicleDetails()
    );
  }

  public GetVehicleAttributeForCompany(ownerCompanyHashID: any) {
    this.vehicleAttributeSerive
      .GetVehicleAttributeForCompany(ownerCompanyHashID)
      .subscribe(
        (res: any) => {
          this.apiResponse = res;
          this.vehicleAttributeList = res.data;
        },
        (error: any) => {
          this.errorMessage = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        },
        () => {
          if (this.isEditMode) {
            if (this.authService.GetHighestRoleLevel() <= RoleLevel.Instance)
              this.vehicleAttributeList
                .filter(
                  x =>
                    this.model.attributeList &&
                    this.model.attributeList.indexOf(x.vehicleAttributeHashId) >
                    -1
                )
                .forEach(x => (x.isChecked = true));
          }
        }
      );
  }

  public GetVehicleDetails() {
    this.sub = this.activeRoute.params.subscribe(params => {
      this.vehicleMasterHashId = params["id"] || "";
      this.isEditMode = true;
      if (this.vehicleMasterHashId != "") {
        this.vehicleService
          .GetVehicleByHashId(this.vehicleMasterHashId, false)
          .subscribe(
            res => {
              this.isLoading = false;
              this.model = res.data;

              this.updateCompanyLink = new WeGoAuthorizedLink(
                this.urlCompanyUpdate + "/" + this.model.ownerCompanyHashID,
                Permission.PR_COMPANY_OVERVIEW,
                PermissionType.EDIT,
                "",
                this.model.ownerName,
                "",
                "",
                true
              );

              this.vtsTroubleShootLink = new WeGoAuthorizedLink(
                this.urlVtsTroubleShoot + "/" + this.model.vehicleMasterHashId,
                Permission.PR_VTS_TROUBLESHOOT,
                PermissionType.VIEW,
                "",
                "LblTroubleShootVTS",
                "",
                "",
                false,
                "fa fa-wrench"
              );

              this.updateVehicleLink = new WeGoAuthorizedLink(
                this.urlVehicleUpdate + "/" + this.model.vehicleMasterHashId,
                Permission.PR_VEHICLES_OVERVIEW,
                PermissionType.EDIT,
                "",
                this.model.licenceTag,
                "",
                "",
                true
              );

              this.vehicleListLink = new WeGoAuthorizedLink(
                this.urlVehicleList,
                Permission.PR_VEHICLES_OVERVIEW,
                PermissionType.VIEW,
                "",
                this.breadCrumbList,
                "",
                "",
                false,
                "fa fa-cab"
              );

              this.locationDataExchangeHashId =
                res.data.locationDataExchangeHashId;
              this.vehicleAttributeList
                .filter(
                  x =>
                    this.model.attributeList &&
                    this.model.attributeList.indexOf(x.vehicleAttributeHashId) >
                    -1
                )
                .forEach(x => (x.isChecked = true));
              if (this.authService.GetHighestRoleLevel() <= RoleLevel.Instance)
                this.GetVehicleAttributeForCompany(
                  this.model.ownerCompanyHashID
                );
            },
            error => {
              this.errorMessage = this.authService.HandleErrorStatusCode(error);
              this.isLoading = false;
            },
            () => {
              this.GetVehicleDamageReport();
            }
          );
      } else {
        this.isLoading = false;
        this.isEditMode = false;
      }
    });
    this.breadCrumbTitle = this.translate.instant("LblVehicleStatus");
    this.breadCrumbList = this.translate.instant("LblListPage", [this.module]);
  }

  // public UpdateVTSVehicleStatus(vehicleStatus: string) {
  //   this.isLoading = true;
  //   this.vehicleService.UpdateVTSVehicleStatus(this.vehicleMasterHashId, vehicleStatus)
  //     .subscribe(
  //     res => {
  //       this.isLoading = false;
  //       this.popupMsg = this.translate.instant('LblVTSVehicleUpdateSuccess', vehicleStatus);
  //       this.ShowSuccessPopup();
  //     },
  //     error => {
  //       this.isLoading = false;
  //       this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
  //     });
  // }

  public LockVTSVehicle() {
    this.isLoading = true;
    this.vehicleService
      .LockVTSVehicle(this.locationDataExchangeHashId, this.isMobileRequest)
      .subscribe(
        res => {
          this.isLoading = false;
          if (res.data) {
            this.popupMsg = this.translate.instant("LblLockSuccessfully");
            this.ShowSuccessPopup();
          } else {
            this.popupMsg = this.translate.instant("LbllockProblem");
            this.popupTitle = this.translate.instant("LblWarning");
            this.ShowSuccessPopup();
          }
        },
        error => {
          this.isLoading = false;
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        }
      );
  }

  public UnLockVTSVehicle() {
    this.isLoading = true;
    this.vehicleService
      .UnLockVTSVehicle(this.locationDataExchangeHashId, this.isMobileRequest)
      .subscribe(
        res => {
          this.isLoading = false;
          if (res.data) {
            this.popupMsg = this.translate.instant("LblUnLockSuccessfully");
            this.ShowSuccessPopup();
          } else {
            this.popupMsg = this.translate.instant("LblUnlockProblem");
            this.popupTitle = this.translate.instant("LblWarning");
            this.ShowSuccessPopup();
          }
        },
        error => {
          this.isLoading = false;
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        }
      );
  }

  public ShowReportSuccessPopup(): void {
    this.successPopupReport.show();
  }

  public HideReportSuccessPopup(): void {
    this.successPopupReport.hide();
  }

  public ConfirmReportSuccessPopup(): void {
    this.GetVehicleDamageReport();
  }

  public ShowSuccessPopup(): void {
    this.successPopup.show();
  }

  public HideSuccessPopup(): void {
    this.successPopup.hide();
  }

  public ConfirmSuccessPopup(): void {
    this.OnBackClick();
  }

  public GetImageURL(imagePath: string) {
    return  WeGoConfig.LEGACY_API_BASE_URL + imagePath;
  }

  public DecimalFormatter(val: string) {
    return this.decimalFormatter.transform(val);
  }

  public GetVehicleDamageReport() {
    this.vehicleService
      .GetVehicleDamageReport(this.vehicleMasterHashId, this.DataListModel)
      .subscribe(
        (res: any) => {
          this.damageReportList = res.data;
          this.DataListModel.totalItems = res.totalRecords;
          this.DataListModel.infoMessage = res.error;
          this.isLoading = false;
        },
        (error: any) => {
          this.errorMessage = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        }
      );
  }

  public OnPageChanged(event: any): void {
    this.DataListModel.currentPage = event.page;
    this.GetVehicleDamageReport();
  }

  public ConfirmSuccessClick(): void {
    this.confirmModal.hide();
    this.UpdateDamageReportStatus();
  }

  public ShowConfirmModal(reportHashId: string): void {
    this.isLoading = false;
    this.confirmMsg = this.translate.instant("LblConfirmResolveDamage");
    this.reportDamageHashId = reportHashId;
    this.confirmModal.show();
  }

  public HideConfirmModal(): void {
    this.confirmModal.hide();
  }

  public GetVTSAddress(): void {
    let latlng = this.model.vtsLocation;
    this.geoLocationService.GetFormatedAddressFromLatlng(latlng, this.model.instanceLanguage).subscribe(
      result => {
        if (result.Response.View.length > 0) {
          if (result.Response.View[0].Result.length > 0) {
            console.log(result.Response.View[0].Result);

            let houseMatch = result.Response.View[0].Result.filter((x: any) => x.MatchLevel == 'houseNumber');
            var matchedAddress: any;
            if (houseMatch.length > 0) {
              matchedAddress = houseMatch[0];
            } else {
              matchedAddress = result.Response.View[0].Result[0];
            }

            this.vtsLocationAddress = matchedAddress.Location.Address.Label;

          } else {
            this.vtsLocationAddress = this.translate.instant('LblAddressNotAvailable');
          }
        } else {
          this.vtsLocationAddress = this.translate.instant(
            'LblAddressNotAvailable'
          );
        }
      },
      error => { }
    );
  }

  GetAttributeName(key: string) {
    let vehicleAttr = this.vehicleAttributeList.find(
      x => x.vehicleAttributeHashId == key
    );

    if (vehicleAttr) return vehicleAttr.attributeName;
    else return "";
  }

  get GetAdditionalAttribute() {
    let vehicleAttrList = this.vehicleAttributeList.filter(
      x =>
        this.model.attributeList &&
        this.model.attributeList.indexOf(x.vehicleAttributeHashId) > -1
    );
    return this.GroupByCategory(vehicleAttrList);
  }

  public GroupByCategory(vehicleAttrList: any) {
    if (vehicleAttrList) {
      let prop = "vehicleAttributeCategoryName";
      return vehicleAttrList.reduce(function (groups: any, item: any) {
        let val = item[prop];
        groups[val] = groups[val] || [];
        groups[val].push(item);
        groups[val] = groups[val].sort((obj1: any, obj2: any) => {
          if (obj1.attributeName > obj2.attributeName) {
            return 1;
          }

          if (obj1.attributeName < obj2.attributeName) {
            return -1;
          }
          return 0;
        });
        return groups;
      }, {});
    } else {
      return {};
    }
  }

  public FormatString(data: string) {
    if (data) return data;
    else return this.translate.instant("LblNA");
  }

  public ReportDamage(vehicleMasterHashId: string) {
    this.reportDamageModal.model.vehicleHashId = vehicleMasterHashId;
    this.reportDamageModal.show();
  }
  public SuccessReportDamage(successMsg: string) {
    this.popupMsg = successMsg;
    this.ShowReportSuccessPopup();
  }

  public KeyOfObject(obj: any) {
    return Object.keys(obj);
  }

  public ConfirmImageSlider(event: any) { }

  ngOnDestroy() {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/vehicle/components/vehicle-information.component.ts